import type { FeedbackMessages } from './en';

const da: FeedbackMessages = {
  qualified: {
    title: 'Tak for din deltagelse i denne undersøgelse!',
    body1: 'Du kan nu lukke browservinduet.',
    body2: 'Vi håber at se dig igen snart.',
    refCode: 'Ref-kode: {code}',
  },
  quotaFull: {
    title: 'Denne undersøgelse er lukket',
    body1: 'Tak for din interesse i vores undersøgelse.',
    body2: 'Vi har desværre allerede modtaget alle de svar, vi har brug for.',
    body3: 'Vi håber at se dig i en af vores fremtidige undersøgelser!',
    refCode: 'Ref-kode: {code}',
  },
  terminated: {
    title: 'Tak for din feedback!',
    body1:
      'Vi håber at se dig igen i vores fremtidige undersøgelser. Indtil da ønsker vi dig en god dag.',
    body2: 'Du kan nu lukke browservinduet.',
    refCode: 'Ref-kode: {code}',
  },
  mismatch: {
    title: 'Tak for din interesse',
    body1: 'Du er desværre ikke i målgruppen for denne specifikke undersøgelse.',
    body2: 'Du kan lukke denne side.',
    code: 'Kode: {code}',
  },
  error: {
    title: 'Vi kan ikke behandle din anmodning',
    linkProblemDetailed:
      'Det link, du har fulgt, har problemer. Kontroller, at linket i adressefeltet matcher det, du har fået, og forsøg igen.',
    linkProblemGeneric:
      'Det link, du har fulgt, har problemer. Forsøg venligst igen.',
    contactPerson:
      'Hvis problemet fortsætter, bedes du give den person, du fik linket fra, besked om dette problem.',
    errorCode: 'Fejlkode: {code}',
  },
};

export default da;
